export const API_ENDPOINT_DEPLOYED = process.env.REACT_APP_API_ENDPOINT_DEPLOYED;
export const API_ENDPOINT_LOCAL = process.env.REACT_APP_API_ENDPOINT_LOCAL;
export const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT;
export const AUTH_ENDPOINT = process.env.REACT_APP_AUTH_ENDPOINT;
export const APP_OFFLINE = process.env.REACT_APP_STATUS === 'offline';
export const NOTIFICATION_ENDPOINT = process.env.REACT_APP_NOTIFICATION_ENDPOINT;
export const STATUSES = {
    initial: "Creating Worksheet...",
    updatingWorksheet: "Updating Worksheet...",
    worksheetCreated: "Worksheet Created - Pending Projections",
    worksheetCreatedNonLux: "Worksheet Created - Pending SKU & PO Creation",
    approvalDenied: "Approval Denied - Pending Projections",
    creatingprojections: "Creating Projections...",
    userErrorprojections: "Errors in Worksheet (Projections) - Pending Projections",
    projectionsCreated: "Projections Created - Pending Net Sales",
    netSalesStart: "Calculating Net Sales...",
    userErrorNet: "Errors in Worksheet (Net Sales) - Pending Net Sales",
    pendingApprovalRequest: "Net Sales Calculated - Pending Approval Request",
    pendingApproval: "Approval Requested - Pending Purchase Approval",
    processingApproval: "Processing PO approval...",
    pendingVendor: "Purchase Approved - Pending Vendor Confirmation",
    vendorConfirmed: "Vendor Confirmed - Pending SKU & PO Creation",
    vendorDenied: "Vendor Denied - Pending Projections",
    skusPoStart: "Creating SKUs and PO - Validating Product data...",
    skusPoAssign: "Creating SKUs and PO - Assigning SKUs...",
    skusPoLs: "Creating SKUs and PO - Creating Products in Lightspeed...",
    skusPoSc: "Creating SKUs and PO - Creating Products in Sellercloud...",
    skusPoValid: "Creating SKUs and PO - Validating SKUs in Sellercloud...",
    skusPoUpload: "Creating SKUs and PO - Updating PO in Sellercloud...",
    userErrorSkus: "Errors in Worksheet (SKUs & PO) - Pending SKU & PO Creation",
    pendingTracking: "SKUs & PO Created - Pending Tracking",
    pendingDelivery: "Tracking Added - Pending Delivery",
    pendingReceiving: "Order Delivered - Pending Receiving",
    pendingResolution: "Order Received - Pending Resolution",
    pendingResolutionApproval: "Order Resolved - Pending Resolution Approval",
    resolutionDenied: "Resolution Denied - Pending Resolution",
    receivingCompleted: "Receiving Completed",
    internalError: "Internal Error",
    archived: "Archived"
};
export const RECEIVED_STATUSES = [
    STATUSES.pendingReceiving,
    STATUSES.pendingResolution,
    STATUSES.pendingResolutionApproval,
    STATUSES.resolutionDenied,
    STATUSES.receivingCompleted,
]